import React, { Suspense, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  ModalHeader,
} from "reactstrap";
import { config } from "../../config";
import LoadingOverlay from "../../component/Loading";
import axios from "axios";
import TableData from "./component/TablePerangkatDesa";
import ModalFormPerangkat from "./component/ModalFormPerangkat";
import { Alert } from "reactstrap";
import InputNumber from "./component/InputNumber";
import { readFile } from "../../util/ReadFile";
import splitBase64Format from "../../util/splitBase64Format";

const Register = () => {
  const history = useHistory();
  const { token } = useParams();
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [provinsiList, setProvinsiList] = useState([]);
  const [kotaList, setKotaList] = useState([]);
  const [kecamatanList, setKecamatanList] = useState([]);
  const [kelurahanList, setKelurahanList] = useState([]);

  const [agamaList, setAgamaList] = useState([]);
  const [etnisList, setEtnisList] = useState([]);
  const [statusHubunganKeluargaList, setStatusHubunganKeluargaList] = useState(
    []
  );
  const [statusKewarganegaraanList, setStatusKewarganegaraanList] = useState(
    []
  );
  const [statusPerkawinanList, setStatusPerkawinanList] = useState([]);
  const [pendidikanList, setPendidikanList] = useState([]);
  const [pekerjaanList, setPekerjaanList] = useState([]);

  const [dataList, setDataList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [registerId, setRegisterId] = useState(null);

  const [modalDelete, setModalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [isAgreed, setIsAgreed] = useState(false);

  const [alertInfo, setAlertInfo] = useState({
    show: false,
    message: "",
    color: "success",
  });

  // State untuk Pagination
  const [currentPage, setCurrentPage] = useState(0); // Spring Boot mulai dari 0
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [form, setForm] = useState({
    provinsiId: null,
    kotaId: null,
    kecamatanId: null,
    kelurahanId: null,
    emailKecamatan: null,
    email: null,
    nomorHpKecamatan: null,
    nomorHp: null,
    alamat: null,
    jumlahDusun: 0,
    jumlahRw: 0,
    jumlahRt: 0,
  });

  const initialFormModal = {
    nik: null,
    nama: null,
    nomorKk: null,
    nomorHp: null,
    namaIbuKandung: null,
    tempatLahir: null,
    tanggalLahir: null,
    jenisKelamin: null,
    magamaId: null,
    metnisId: null,
    mpendidikanId: null,
    mpekerjaanId: null,
    mstatusPerkawinanId: null,
    mstatusHubunganKeluargaId: null,
    mstatusKewarganegaraanId: null,
    alamat: null,
    rt: null,
    rw: null,
    foto: null,
  };

  const [formModal, setFormModal] = useState(initialFormModal);

  const toggleModalDelete = (id = null) => {
    setDeleteId(id);
    setModalDelete(!modalDelete);
  };

  const checkRegisterForm = async () => {
    if (!token) {
      history.push("/not-found");
      return;
    }

    try {
      const decodedString = atob(token);

      const [registerId, email] = decodedString.split("|");

      // console.log("email: ", email);
      // console.log("registerId: ", registerId);
      setRegisterId(registerId);

      if (!registerId || !email) {
        throw new Error("Format token tidak valid");
      }

      setLoading(true);

      const res = await axios.get(
        `${config.BASE_URL}registerDraft/findDraft/${registerId}`,
        { params: { email } }
      );
      if (res.data && res.data.data) {
        // console.log("res.data.data: ", res.data.data);
        setForm(res.data.data);
      } else {
        history.push("/not-found");
      }
    } catch (err) {
      history.push("/not-found");
      showAlert(
        "Tautan pendaftaran tidak valid atau sudah kadaluwarsa.",
        "danger"
      );

      // setTimeout(() => {
      //   history.push("/not-found");
      // }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const fetchRegisterPetugas = async (id, page = 0, size = 10) => {
    setLoading(true);
    try {
      const params = {
        registerId: id,
        page: page,
        size: size,
        sort: "created",
        urutan: "desc",
      };

      const res = await axios.get(
        `${config.BASE_URL}registerPetugas/pagination/registerId`,
        { params }
      );

      if (res.data && res.data.data) {
        const responseData = res.data.data;

        setDataList(responseData || []);
        setTotalElements(responseData.totalElements || 0);
        setTotalPages(responseData.totalPages || 0);
        setCurrentPage(responseData.number || 0);
      }
    } catch (err) {
      showAlert("Gagal memuat daftar petugas.", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (registerId) {
      fetchRegisterPetugas(registerId, 0, pageSize);
    }
  }, [registerId]);

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      fetchRegisterPetugas(registerId, newPage, pageSize);
    }
  };

  useEffect(() => {
    checkRegisterForm();
  }, [token]);

  const fetchAgama = async () => {
    try {
      const res = await axios.get(`${config.BASE_URL}agama/search`);
      setAgamaList(res.data.data);
    } catch (err) {}
  };

  const showAlert = (message, color = "success") => {
    setAlertInfo({ show: true, message, color });
    setTimeout(() => setAlertInfo({ ...alertInfo, show: false }), 4000);
  };

  const fetchEtnis = async () => {
    try {
      const res = await axios.get(`${config.BASE_URL}etnis/search`);
      setEtnisList(res.data.data);
    } catch (err) {}
  };

  const fetchStatusHubunganKeluarga = async () => {
    try {
      const res = await axios.get(
        `${config.BASE_URL}statusHubunganKeluarga/search`
      );
      setStatusHubunganKeluargaList(res.data.data);
    } catch (err) {}
  };

  const fetchStatusKewarganegaraan = async () => {
    try {
      const res = await axios.get(
        `${config.BASE_URL}statusKewarganegaraan/search`
      );
      setStatusKewarganegaraanList(res.data.data);
    } catch (err) {}
  };

  const fetchStatusPerkawinan = async () => {
    try {
      const res = await axios.get(`${config.BASE_URL}statusPerkawinan/search`);
      setStatusPerkawinanList(res.data.data);
    } catch (err) {}
  };

  const fetchStatusPendidikan = async () => {
    try {
      const res = await axios.get(`${config.BASE_URL}pendidikan/search`);
      setPendidikanList(res.data.data);
    } catch (err) {}
  };

  const fetchStatusPekerjaan = async () => {
    try {
      const res = await axios.get(`${config.BASE_URL}pekerjaan/search`);
      setPekerjaanList(res.data.data);
    } catch (err) {}
  };

  const fetchProvinsi = async () => {
    try {
      const res = await axios.get(
        `${config.BASE_URL}referensi/provinsi/search`
      );

      setProvinsiList(res.data.data);
    } catch (err) {
      // console.error(err);
    }
  };

  useEffect(() => {
    fetchStatusPekerjaan();
    fetchStatusPendidikan();
    fetchStatusPerkawinan();
    fetchStatusKewarganegaraan();
    fetchStatusHubunganKeluarga();
    fetchEtnis();
    fetchProvinsi();
    fetchAgama();
  }, []);

  useEffect(() => {
    if (form.provinsiId) {
      const fetchKota = async () => {
        const res = await axios.get(
          `${config.BASE_URL}referensi/kota/provinsi`,
          {
            params: { provinsiId: form.provinsiId },
          }
        );
        setKotaList(res.data.data);
      };
      fetchKota();
    }
  }, [form.provinsiId]);

  useEffect(() => {
    if (form.kotaId) {
      const fetchKec = async () => {
        const res = await axios.get(
          `${config.BASE_URL}referensi/kecamatan/kecamatan/${form.kotaId}`
        );
        setKecamatanList(res.data.data);
      };
      fetchKec();
    }
  }, [form.kotaId]);

  useEffect(() => {
    if (form.kecamatanId) {
      const fetchKel = async () => {
        const res = await axios.get(
          `${config.BASE_URL}referensi/kelurahan/kecamatan/${form.kecamatanId}`
        );
        setKelurahanList(res.data.data);
      };
      fetchKel();
    }
  }, [form.kecamatanId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "provinsiId") {
      setForm({
        ...form,
        provinsiId: value,
        kotaId: null,
        kecamatanId: null,
        kelurahanId: null,
      });
      setKotaList([]);
      setKecamatanList([]);
      setKelurahanList([]);
    } else if (name === "kotaId") {
      setForm({
        ...form,
        kotaId: value,
        kecamatanId: null,
        kelurahanId: null,
      });
      setKecamatanList([]);
      setKelurahanList([]);
    } else if (name === "kecamatanId") {
      setForm({
        ...form,
        kecamatanId: value,
        kelurahanId: null,
      });
      setKelurahanList([]);
    } else {
      const integerFields = ["jumlahDusun", "jumlahRw", "jumlahRt"];
      if (integerFields.includes(name)) {
        const intValue =
          value === "" || value === null ? 0 : parseInt(value, 10);
        setForm({ ...form, [name]: intValue });
      } else {
        setForm({ ...form, [name]: value });
      }
    }
  };
  const handleInputModalChange = (e) => {
    const { name, value } = e.target;

    // Pastikan kita mengupdate state formModal, bukan form (form utama)
    setFormModal((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (file) => {
    setFormModal((prev) => ({
      ...prev,
      foto: file,
    }));
  };

  const toggleFormModal = () => setModalFormOpen(!modalFormOpen);

  const handleConfirmAdd = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      let fileSplitBase64 = null;

      // Cek apakah ada foto dan apakah foto tersebut merupakan File baru (Object)
      // Jika foto adalah String (data lama), kita tidak perlu readFile lagi
      if (formModal.foto instanceof Blob || formModal.foto instanceof File) {
        const fileBase64 = await readFile(formModal.foto);
        fileSplitBase64 = splitBase64Format(fileBase64);
      } else if (typeof formModal.foto === "string") {
        // Jika foto adalah string, gunakan data yang sudah ada atau kirim string tersebut
        fileSplitBase64 = formModal.foto;
      }
      if (isEditing) {
        setDataList(
          dataList.map((item) =>
            item.registerId === editId
              ? { ...formModal, registerId: editId }
              : item
          )
        );

        const payload = [
          {
            ...formModal,
            registerId,
            createdBy: "User Landing Page",
            updatedBy: "User Landing Page",
            isactive: "Y",
            foto: fileSplitBase64 ? fileSplitBase64 : null,
          },
        ];

        await axios.put(`${config.BASE_URL}registerPetugas/update`, payload);

        fetchRegisterPetugas(registerId, 0, pageSize);

        showAlert("✅ Data berhasil diupdate");
      } else {
        const payload = [
          {
            ...formModal,
            foto: fileSplitBase64 ? fileSplitBase64 : null,
            provinsiId: form.provinsiId,
            kotaId: form.kotaId,
            kecamatanId: form.kecamatanId,
            kelurahanId: form.kelurahanId,
            organizationId: form.organizationId,
            registerId,
            createdBy: "User Landing Page",
            updatedBy: "User Landing Page",
            isactive: "Y",
          },
        ];

        await axios.post(`${config.BASE_URL}registerPetugas/create`, payload);

        fetchRegisterPetugas(registerId, 0, pageSize);
        showAlert("✅ Petugas berhasil ditambahkan");
      }
      setFormModal(initialFormModal);
      setModalFormOpen(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        showAlert(`❌ ${error?.response?.data?.message}`, "danger");
      } else {
        showAlert("❌ Terjadi kesalahan", "danger");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setFormModal({
      ...item,
      tanggalLahir: item.tanggalLahir ? item.tanggalLahir.substring(0, 10) : "",
    });
    setIsEditing(true);
    setEditId(item.registerPetugasId);
    setModalFormOpen(true);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await axios.delete(
        `${config.BASE_URL}registerPetugas/remove/${deleteId}?mUserId=User Landing Page`
      );

      // Refresh data
      fetchRegisterPetugas(registerId, currentPage, pageSize);
      showAlert("✅ Data berhasil dihapus");
      setModalDelete(false); // Tutup modal
    } catch (error) {
      showAlert("❌ Gagal menghapus data", "danger");
    } finally {
      setLoading(false);
    }
  };

  const onSaveDraft = async () => {
    setLoading(true);
    try {
      // Sesuaikan endpoint dengan API backend Anda, misal: /register/draft
      const payload = [
        {
          ...form,
          registerId,
          createdBy: "User Landing Page",
          updatedBy: "User Landing Page",
          isactive: "Y",
        },
      ];
      await axios.post(`${config.BASE_URL}register/create/draft`, payload);
      showAlert("Draft pendaftaran berhasil disimpan!");
    } catch (error) {
      // console.error("Error saving draft:", error);
      showAlert("❌ Gagal menyimpan draft.", "danger");
    } finally {
      setLoading(false);
    }
  };

  const onSubmitFinal = async () => {
    setLoading(true);
    try {
      if (!dataList || dataList.length === 0) {
        showAlert(
          "❌ Tidak ada data untuk dikirim. Silakan isi form terlebih dahulu.",
          "warning"
        );
        return;
      }
      const payload = [
        {
          ...form,
          registerId,
          nama: "User Landing Page",
          createdBy: "User Landing Page",
          updatedBy: "User Landing Page",
          isactive: "Y",
        },
      ];

      console.log("payload: ", payload);

      // await axios.post(`${config.BASE_URL}register/create`, payload);
      setDataList([]);
      setModalConfirm(false);
      showAlert("Data berhasil dikirim!");
      history.push("/registration-success");
    } catch (error) {
      showAlert(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "❌ Gagal menyimpan data.",
        "danger"
      );
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    // Hanya angka 0-9
    if (!/^[0-9]+$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  // Fungsi untuk mengecek apakah form sudah lengkap
  const isFormValid = () => {
    const requiredFields = [
      form.provinsiId,
      form.kotaId,
      form.kecamatanId,
      form.kelurahanId,
      form.nomorHpKecamatan,
      form.emailKecamatan,
      form.nomorHp,
      form.email,
      form.alamat,
      form.jumlahDusun,
      form.jumlahRw,
      form.jumlahRt,
    ];

    const isAllFieldsFilled = requiredFields.every(
      (field) => field !== "" && field !== null && field !== undefined
    );

    const isDataListNotEmpty = dataList && dataList.length > 0;

    return isAllFieldsFilled && isDataListNotEmpty && isAgreed;
  };

  return (
    <div
      style={{
        backgroundColor: "#f4f7f6",
        minHeight: "100vh",
        padding: "40px 0",
      }}
    >
      {loading && <LoadingOverlay />}
      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 9999,
          minWidth: "300px",
        }}
      >
        <Alert
          color={alertInfo.color}
          isOpen={alertInfo.show}
          toggle={() => setAlertInfo({ ...alertInfo, show: false })}
          className="shadow-lg border-0"
        >
          {alertInfo.message}
        </Alert>
      </div>
      <ModalFormPerangkat
        isOpen={modalFormOpen}
        toggle={toggleFormModal}
        form={formModal}
        handleFileChange={handleFileChange}
        handleInputChange={handleInputModalChange}
        handleConfirm={handleConfirmAdd}
        isEditing={isEditing}
        agamaList={agamaList}
        etnisList={etnisList}
        pendidikanList={pendidikanList}
        pekerjaanList={pekerjaanList}
        statusPerkawinanList={statusPerkawinanList}
        statusHubunganKeluargaList={statusHubunganKeluargaList}
        statusKewarganegaraanList={statusKewarganegaraanList}
      />

      <Container fluid style={{ width: "95%" }}>
        <Row className="justify-content-center">
          <Col md={11}>
            <CardHeader className="bg-white border-0 pt-4 d-flex justify-content-between align-items-center">
              {/* SISI KIRI: Breadcrumb sederhana */}
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 bg-transparent p-0">
                  <li className="breadcrumb-item text-muted">Registrasi</li>
                  <li
                    className="breadcrumb-item active fw-bold text-primary"
                    aria-current="page"
                  >
                    Form Pendaftaran
                  </li>
                </ol>
              </nav> */}

              {/* SISI KANAN: Tombol Simpan Draft */}
              <Button
                size="sm"
                color="info"
                className="px-5 fw-bold shadow me-3 text-white"
                onClick={onSaveDraft}
                disabled={loading}
              >
                {loading ? (
                  "Loading..."
                ) : (
                  <>
                    <i className="fa fa-save me-2"></i> Simpan Draft
                  </>
                )}
              </Button>
            </CardHeader>
            <Card className="shadow-sm border-0 mb-4">
              <CardHeader className="bg-white border-0 pt-4">
                <h5 className="fw-bold">Form Pendaftaran</h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Provinsi <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="provinsiId"
                        value={form.provinsiId}
                        onChange={handleInputChange}
                        required // Menambahkan validasi wajib
                      >
                        <option value="">Pilih Provinsi</option>
                        {provinsiList.map((item) => (
                          <option key={item.provinsiId} value={item.provinsiId}>
                            {item.nama}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Kota/Kabupaten <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="kotaId"
                        value={form.kotaId}
                        onChange={handleInputChange}
                        disabled={!form.provinsiId}
                        required // Menambahkan validasi wajib
                      >
                        <option value="">Pilih Kota</option>
                        {kotaList.map((item) => (
                          <option key={item.kotaId} value={item.kotaId}>
                            {item.nama}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Kecamatan <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="kecamatanId"
                        value={form.kecamatanId}
                        onChange={handleInputChange}
                        disabled={!form.kotaId}
                        required // Menambahkan validasi wajib
                      >
                        <option value="">Pilih Kecamatan</option>
                        {kecamatanList.map((item) => (
                          <option
                            key={item.kecamatanId}
                            value={item.kecamatanId}
                          >
                            {item.nama}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Kelurahan/Desa <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="kelurahanId"
                        value={form.kelurahanId}
                        onChange={handleInputChange}
                        disabled={!form.kecamatanId}
                        required // Menambahkan validasi wajib
                      >
                        <option value="">Pilih Kelurahan</option>
                        {kelurahanList.map((item) => (
                          <option
                            key={item.kelurahanId}
                            value={item.kelurahanId}
                          >
                            {item.nama}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  {/* FIELD NOMOR HP KECAMATAN */}
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold small">
                        Nomor HP Kecamatan{" "}
                        <span className="text-danger">*</span> :
                      </Label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-end-0">
                          <small className="fw-bold text-muted">+62</small>
                        </span>
                        <Input
                          name="nomorHpKecamatan"
                          type="text"
                          placeholder="812xxxxxx"
                          value={form.nomorHpKecamatan}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress}
                          className="py-2 border-start-0"
                          required // Sudah ada, tetap dipertahankan
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Email Kecamatan <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        name="emailKecamatan"
                        value={form.emailKecamatan}
                        onChange={handleInputChange}
                        placeholder="kecamatan@mail.com"
                        required // Menambahkan validasi wajib
                      />
                    </FormGroup>
                  </Col>

                  {/* FIELD NOMOR HP KELURAHAN */}
                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold small">
                        Nomor HP Kelurahan/Desa{" "}
                        <span className="text-danger">*</span> :
                      </Label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-end-0">
                          <small className="fw-bold text-muted">+62</small>
                        </span>
                        <Input
                          name="nomorHp"
                          type="text"
                          placeholder="812xxxxxx"
                          value={form.nomorHp}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress}
                          className="py-2 border-start-0"
                          required // Sudah ada
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md={6} className="mb-3">
                    <FormGroup>
                      <Label className="fw-bold">
                        Email Kelurahan <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleInputChange}
                        placeholder="kelurahan@mail.com"
                        required // Menambahkan validasi wajib
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup>
                      <Label className="fw-bold">
                        Alamat <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="alamat"
                        value={form.alamat}
                        onChange={handleInputChange}
                        placeholder="Tulis alamat detail..."
                        required // Menambahkan validasi wajib
                      />
                    </FormGroup>
                  </Col>

                  {/* FIELD TAMBAHAN: JUMLAH DUSUN, RW, RT */}
                  <Col md={4} className="mb-3">
                    <InputNumber
                      label="Jumlah Dusun"
                      name="jumlahDusun"
                      value={form.jumlahDusun}
                      onChange={handleInputChange}
                      required // Pastikan komponen InputNumber mendukung prop required
                    />
                  </Col>

                  <Col md={4} className="mb-3">
                    <InputNumber
                      label="Jumlah RW"
                      name="jumlahRw"
                      value={form.jumlahRw}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>

                  <Col md={4} className="mb-3">
                    <InputNumber
                      label="Jumlah RT"
                      name="jumlahRt"
                      value={form.jumlahRt}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <TableData
              dataList={dataList}
              onEdit={handleEdit}
              onDelete={toggleModalDelete}
              onAddClick={() => {
                if (!form.kelurahanId) {
                  showAlert(
                    "Silahkan isi data kelurahan/desa terlebih dahulu",
                    "warning"
                  );
                  return;
                }
                setIsEditing(false);
                // setFormModal(initialFormModal);
                setModalFormOpen(true);
              }}
              pagination={{
                currentPage,
                totalPages,
                totalElements,
                onPageChange: handlePageChange,
              }}
            />

            <Card className="border-warning bg-light-warning mb-4 shadow-sm">
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <i className="fa fa-info-circle text-warning fa-2x"></i>
                  </div>
                  <div>
                    <h6 className="fw-bold text-dark">
                      Konfirmasi Pemeriksaan Data
                    </h6>
                    <p className="text-muted small mb-3">
                      Silakan tinjau kembali seluruh informasi yang telah Anda
                      masukkan. Pastikan data wilayah, kontak
                      kecamatan/kelurahan, serta jumlah RT/RW sudah sesuai
                      dengan kondisi lapangan terbaru.
                      <span className="text-danger fw-bold">
                        {" "}
                        Data yang sudah dikirim tidak dapat diubah kembali.
                      </span>
                    </p>

                    <FormGroup check inline>
                      <Label
                        check
                        className="fw-bold text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        <Input
                          type="checkbox"
                          className="me-2"
                          checked={isAgreed}
                          onChange={(e) => setIsAgreed(e.target.checked)}
                        />
                        Saya menyatakan bahwa seluruh data yang diisi sudah
                        benar, lengkap, dan siap untuk diproses.
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              </CardBody>
            </Card>

            <div className="d-flex justify-content-end mt-4">
              <Button
                color="success"
                size="lg"
                className="px-5 fw-bold shadow"
                onClick={() => setModalConfirm(true)}
                disabled={!isFormValid() || loading}
              >
                Submit Final
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)} centered>
        <ModalHeader className="bg-danger text-white">
          Konfirmasi Hapus
        </ModalHeader>
        <ModalBody className="py-4">
          Apakah Anda yakin ingin menghapus data petugas ini?
          <br />
          <small className="text-muted">
            Tindakan ini tidak dapat dibatalkan.
          </small>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            color="secondary"
            onClick={() => setModalDelete(false)}
          >
            Batal
          </Button>
          <Button size="sm" color="danger" onClick={handleDelete}>
            Ya, Hapus Data
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modalConfirm}
        toggle={() => setModalConfirm(false)}
        centered
      >
        <ModalHeader>Konfirmasi</ModalHeader>
        <ModalBody>Kirim seluruh data pendaftaran?</ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={() => setModalConfirm(false)}>
            Batal
          </Button>
          <Button size="sm" color="success" onClick={onSubmitFinal}>
            Ya, Kirim
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Register;
